{
  "title": "ops 열람",
  "loading": "ops 를 읽는 중입니다…",
  "needEntryTitle": "먼저 입장해야 합니다",
  "needEntryBody": "이 화면은 입장한 연맹원에게만 보입니다. 공용 입장 코드와 게임 ID 로 들어오면 이 자리에 이번 ops 가 뜹니다.",
  "needEntryCta": "입장 화면으로",
  "waitingTitle": "아직 confirm 한 ops 가 없습니다",
  "waitingBody": "CT 가 ops 를 confirm 하면 이 자리에 rally 목록이 뜹니다. 화면을 열어 둔 채 기다리면 됩니다. 새로고침하지 않아도 도착합니다.",
  "pickTitle": "무엇을 들을지 고릅니다",
  "pickBody": "아래 목록에서 자기 rally 를 누르면 여기에 이름과 카운트다운이 뜹니다.",
  "pickWhy": "화면이 대신 골라 주지 않습니다. 계정을 여럿 쓰면 접속에 쓴 ID 와 이번 ops 에서 맡은 자리가 다를 수 있고, 그때 화면이 고른 것은 틀린 것입니다.",
  "listenLabel": "듣기",
  "listeningLabel": "듣는 중",
  "stopLabel": "그만",
  "highlightLabel": "눈으로 따라가기",
  "highlightOnLabel": "따라가는 중",
  "listTitle": "이번 ops 의 rally",
  "listCount": "rally {n} 줄",
  "columnOpen": "개시까지",
  "openPassed": "개시 지남",
  "columnOpened": "개시함",
  "columnImpact": "착탄",
  "columnOffset": "main 착탄 대비",
  "rosterGone": "명부에서 내려간 사람",
  "progressLabel": "행군 출발부터 착탄까지 온 만큼",
  "soundOne": "소리는 고른 하나에서만 납니다. 여럿을 눈으로 따라가도 소리는 하나입니다.",
  "lockedTitle": "소리가 아직 잠겨 있습니다",
  "armLabel": "소리 켜기",
  "muteLabel": "소리 끄기",
  "unmuteLabel": "소리 켜기",
  "mutedTitle": "소리를 껐습니다",
  "mutedBody": "화면의 숫자는 그대로 흐릅니다. 다시 켜면 그때부터 signal 이 울립니다. 껐던 동안 지나간 개시는 누락으로 세지 않습니다.",
  "mutedBodyPassed": "화면의 숫자는 그대로 흐릅니다. 이 rally 의 개시는 지났습니다. 다른 rally 를 고르고 소리를 다시 켜면 그쪽에서 울립니다. 껐던 동안 지나간 개시는 누락으로 세지 않습니다.",
  "missedTitle": "이 개시는 지나갔습니다",
  "missedBody": "소리를 내지 않습니다. 늦게 울리는 signal 을 개시로 믿으면 더 늦게 누르게 되기 때문입니다.",
  "passedBody": "소리는 제때 울렸습니다. 이 개시는 끝났고, 다음 rally 를 고르면 그쪽으로 옮겨 갑니다.",
  "passedBodyMuted": "소리는 제때 울렸습니다. 이 개시는 끝났고, 다음 rally 를 고르고 소리를 다시 켜면 그쪽으로 옮겨 갑니다.",
  "offAtOpenBody": "개시 때 소리가 꺼져 있었습니다. 다른 rally 를 고르면 그쪽에서 울립니다.",
  "appMissedBody": "소리를 제때 울리지 못했습니다. 다른 rally 를 고르면 그쪽에서 울립니다.",
  "appMissedBodyMuted": "소리를 제때 울리지 못했습니다. 다른 rally 를 고르고 소리를 다시 켜면 그쪽에서 울립니다.",
  "audioSuspended": "오디오가 잠겨 있습니다. 브라우저는 사람이 화면을 한 번 누르기 전에는 소리를 내지 않습니다. 바로 아래 버튼을 한 번 누르면 풀립니다. iPhone 이라면 측면의 무음 스위치도 함께 확인해 주세요.",
  "audioClosed": "오디오가 닫혔습니다. 페이지를 새로 열어야 합니다.",
  "audioNotRunning": "오디오 상태가 running 이 아닙니다 ({state}).",
  "droppedMarkers": "박 {n} 개는 이미 지난 시각이라 다시 걸지 않았습니다. 남은 박과 출발음은 제자리에 울립니다.",
  "selectionLocal": "고른 것은 이 화면에만 남습니다. 다른 사람의 화면은 바뀌지 않습니다.",
  "signalNoAudio": "이 브라우저에는 소리를 낼 장치가 없습니다. 화면의 숫자로 따라가 주세요."
}
